import styled from 'styled-components';

const Container = styled.div``;

const LogoutContainer = styled.div`
  position: fixed;
  right: 0;
  top: 0;
  background-color: #fff;
  padding: 20px 30px;
  border-radius: 0 0 0 60px;
  box-shadow: 10px 10px 100px 10px rgba(0, 0, 0, 0.1);
`;

export default {
  Container,
  LogoutContainer
};



// WEBPACK FOOTER //
// ./src/pages/Authenticated/styles.js